import type { Job } from "~/types/job";
import { dataLayerPush } from "./data-layer-push";

function toUniqueValueString(
  strings: undefined | string | (string | undefined)[]
) {
  if (!strings) {
    return "";
  }
  if (typeof strings === "string") {
    return strings;
  }
  // Only unique values
  return [...new Set(strings).values()].sort().join(",");
}

export function trackingForJobAd(job: Job) {
  const locs = job.data.locations;

  dataLayerPush({
    jobAdIdClient: job.data.idClient,
    jobAdJobNumber: job.data.jobNumber,
    jobAdSubClients: toUniqueValueString(job.data.subClients),
    jobAdBusinessUnit: job.data.businessUnit,
    jobAdCategory: job.data.category,
    jobAdCompany: job.data.company,
    jobAdContract: job.data.contract,
    jobAdEmploymentType: toUniqueValueString(job.data.employmentType),
    jobAdClassification: job.data.classification,
    jobAdEntryLevel: job.data.entryLevel,
    jobAdJobField: toUniqueValueString(job.data.jobField),
    jobAdLanguage: job.data.language,
    jobAdRemote: job.data.remote,
    jobAdLocationsName: toUniqueValueString(locs?.map((l) => l.name)),
    jobAdLocationsCityState: toUniqueValueString(locs?.map((l) => l.cityState)),
    jobAdLocationsState: toUniqueValueString(locs?.map((l) => l.state)),
    jobAdLocationsCountry: toUniqueValueString(locs?.map((l) => l.country)),
    jobAdLocationsContinent: toUniqueValueString(locs?.map((l) => l.continent)),
  });
}
